import React, { useEffect, useRef, useState } from "react";

/**
 * Slim gold progress bar fixed to the very top of the viewport that fills
 * as the user scrolls the page. Purely presentational, GPU-friendly (scaleX).
 */
export const ScrollProgress = () => {
  const [p, setP] = useState(0);
  const raf = useRef(0);
  useEffect(() => {
    const onScroll = () => {
      cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        const el = document.documentElement;
        const max = el.scrollHeight - el.clientHeight;
        setP(max > 0 ? Math.min(el.scrollTop / max, 1) : 0);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf.current); };
  }, []);
  return (
    <div aria-hidden="true" className="fixed top-0 left-0 right-0 z-[60] h-[3px] pointer-events-none" data-testid="scroll-progress">
      <div
        className="h-full origin-left bg-gradient-to-r from-[color:var(--gold)] to-[color:var(--gold-soft)]"
        style={{ transform: `scaleX(${p})`, boxShadow: "0 0 12px rgba(223,200,120,0.5)" }}
      />
    </div>
  );
};

export default ScrollProgress;
